import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';

import { of } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { EipRegistration } from './eip.registration';
import { EipLawsuit } from './eip.lawsuit';
import { EipDigitalFile } from './eip.digital-file';
import { loadApiRootSuccessAction } from '@schir-int-client/api-root';
import { doNothingAction } from '@schir-int-client/ngrx-helpers';

@Injectable()
export class EipEffects {
	constructor(
		private actions: Actions,
		private registration: EipRegistration,
		private lawsuit: EipLawsuit,
		private digitalFile: EipDigitalFile
	) {}

	register = createEffect(() =>
		this.actions.pipe(
			ofType(loadApiRootSuccessAction),
			switchMap(({ apiRoot }) => {
				if (this.registration.isConfigured() && !this.registration.isStarted()) {
					console.log('Connect to eIP...');
					this.registration.start(apiRoot.eipConfig);
				} else {
					console.log('No EIP-Parameters -> not connecting to EIP');
				}
				return of(doNothingAction());
			})
		)
	);

	// ungetestet, TODO: komplettieren oder ins backend migrieren
	// @Effect({ dispatch: false })
	// saveSchiffszertifikat = this.actions.pipe(
	// 	ofType(VerfahrenActions.DOWNLOAD_SCHIFFSZERTIFIKAT_SUCCESS),
	// 	tap(action => {
	// 		const success: DownloadSchiffszertifikatSuccessAction = (<DownloadSchiffszertifikatSuccessAction>action);
	// 		const verfahren: VerfahrenResource = success.verfahren;
	// 		const blob: Blob = success.data;
	//
	// 		console.log("hier bin ich");
	//
	// 		this.lawsuit.sendActivateLawsuitContextRequest(verfahren.aktenzeichen);
	// 		this.digitalFile.sendCreateDigitalFile();
	// 	})
	// );
}
